import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true, ...rest }) => (
  <motion.div
    {...rest}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`text-xs font-mono uppercase tracking-[0.25em] text-zinc-500 ${className}`}>{children}</p>
);

export const SectionHeading = ({ overline, title, className = "" }) => (
  <Reveal className={`max-w-3xl ${className}`}>
    <Overline className="mb-5" data-testid={`overline-${overline}`}>{overline}</Overline>
    <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif tracking-tight leading-[1.05]">{title}</h2>
  </Reveal>
);
